"use client";
import React, { useEffect, useState } from "react";
import JobsHeader2 from "./JobsHeader2";
import JobCard from "./JobCard";

const AllJobs = ({ filteredJobs }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch jobs data from API
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(
          "https://final-project-api-alpha.vercel.app/api/jobs"
        );
        const data = await response.json();
        setJobs(data); // Save data to state
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false); // Set loading to false when the data is fetched
      }
    };

    fetchJobs();
  }, []); // Empty dependency array to run this only once on mount

  if (loading) {
    return <div className="text-center text-lg font-semibold py-20">Loading...</div>;
  }

  // Helper function to handle safe lowercasing
  const safeToLowerCase = (str) => {
    return str ? str.toLowerCase() : ""; // Return empty string if str is undefined or null
  };

  // Filter jobs based on search and filter criteria
  const filteredData = jobs.filter((job) => {
    const matchesTitle =
      safeToLowerCase(job.title).includes(safeToLowerCase(filteredJobs.jobTitle)) || !filteredJobs.jobTitle;
    const matchesLocation =
      safeToLowerCase(job.company_city).includes(safeToLowerCase(filteredJobs.location)) || !filteredJobs.location;

    // Checking if salary is within the range of salary_min and salary_max
    const matchesSalary =
      (filteredJobs.salary >= job.salary_min && filteredJobs.salary <= job.salary_max) ||
      !filteredJobs.salary;

    return matchesTitle && matchesLocation && matchesSalary;
  });

  return (
    <section className="px-32 pt-20 pb-20 bg-white max-md:px-16 max-md:pt-0 max-md:pb-12 max-sm:px-6 max-sm:pt-0 max-sm:pb-8">
      <link
        href="https://fonts.googleapis.com/css2?family=Clash+Display:wght@400;600&family=Epilogue:wght@400;600;700&family=Inter:wght@400&display=swap"
        rel="stylesheet"
      />
      <JobsHeader2 />

      {filteredData.length === 0 ? (
        <div className="text-center text-lg font-semibold py-20">
          No Matching Data Found...
          <br />Please Try Another Keyword!
        </div>
      ) : (
        <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
          {filteredData.map((job) => (
            <JobCard key={job._id} {...job} />
          ))}
        </div>
      )}
    </section>
  );
};

export default AllJobs;
